import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=8b11b090&scoped=true&"
import script from "./QuickUser.vue?vue&type=script&lang=js&"
export * from "./QuickUser.vue?vue&type=script&lang=js&"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=8b11b090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b11b090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b11b090')) {
      api.createRecord('8b11b090', component.options)
    } else {
      api.reload('8b11b090', component.options)
    }
    module.hot.accept("./QuickUser.vue?vue&type=template&id=8b11b090&scoped=true&", function () {
      api.rerender('8b11b090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/QuickUser.vue"
export default component.exports